// ts-ignore-file
import React from "react";
import { createRoot } from "react-dom/client";
import { Alert, ThemeProvider } from '@equinor/opt-ui-core';
import { NotificationApi } from "./NotificationApi";
;
const Notification = NotificationApi;
// Utility methods
const setPlacement = (styleNode, placement) => {
    if (placement.includes("top"))
        styleNode.top = "16px";
    if (placement.includes("bottom"))
        styleNode.bottom = "16px";
    if (placement.includes("start"))
        styleNode.left = "16px";
    if (placement.includes("end"))
        styleNode.right = "16px";
    if (!placement.includes("-")) {
        styleNode.margin = "0 auto";
        styleNode.left = "0";
        styleNode.right = "0";
    }
};
const createNotifyStackContainer = (placement, zIndex) => {
    const id = "opt-notifications";
    let node = document.getElementById(id);
    if (!node) {
        node = document.createElement("span");
        node.id = id;
        node.style.position = "fixed";
        node.style.display = "grid";
        node.style.gridGap = "16px";
        if (zIndex && (typeof zIndex === "string" || typeof zIndex === "number")) {
            node.style.zIndex = `${zIndex}`;
        }
        setPlacement(node.style, placement);
        document.body.appendChild(node);
    }
    return node;
};
const createNotifyContainer = (key, containerNode) => {
    const index = containerNode.children.length + 1;
    const id = key || `opt-notification--${index}`;
    let node = document.getElementById(id);
    if (!node) {
        node = document.createElement("span");
        node.id = id;
        containerNode.insertBefore(node, containerNode.childNodes[0]);
    }
    return node;
};
/**
 * Show notification
 *
 * @param {*} config
 * @param {*} children
 */
Notification.show = (tmpConfig, children = null) => {
    if (typeof window === 'undefined')
        return;
    const { theme, ...config } = tmpConfig;
    const placement = config.placement || 'bottom-start';
    const containerNode = createNotifyStackContainer(placement, config.zIndex);
    const mountNode = createNotifyContainer(config.key, containerNode);
    const root = createRoot(mountNode);
    const handleClose = (cCode, mNode) => () => {
        setTimeout(() => {
            root.unmount();
            mNode.remove();
            if (cCode.children.length === 0) {
                cCode.remove();
            }
        }, 500);
    };
    root.render(React.createElement(ThemeProvider, { theme: { mode: theme?.mode || 'light' } },
        React.createElement(NotificationApi, { ...config, open: true, autoHide: true, disablePortal: true, closeOnClickOutside: false, onClose: handleClose(containerNode, mountNode), position: "static" }, children)));
};
/**
 * Show info alert notification.
 *
 * @param {*} config
 */
Notification.info = (config) => {
    Notification.show(config, React.createElement(Alert, { showIcon: true, title: config.message, severity: "info" }));
};
/**
 * Show success alert notification.
 *
 * @param {*} config
 */
Notification.success = (config) => {
    Notification.show(config, React.createElement(Alert, { showIcon: true, title: config.message, severity: "success" }));
};
/**
 * Show warning alert notification.
 *
 * @param {*} config
 */
Notification.warning = (config) => {
    Notification.show(config, React.createElement(Alert, { showIcon: true, title: config.message, severity: "warning" }));
};
/**
 * Show error alert notification.
 *
 * @param {*} config
 */
Notification.error = (config) => {
    Notification.show(config, React.createElement(Alert, { showIcon: true, title: config.message, severity: "error" }));
};
export default Notification;
